class ProductShowcase extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-showcase-slide]'));
    this.prevBtn = this.querySelector('[data-showcase-prev]');
    this.nextBtn = this.querySelector('[data-showcase-next]');
    this.currentIndex = Math.max(
      0,
      this.slides.findIndex((slide) => slide.classList.contains('is-active'))
    );
    this.isAnimating = false;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.slides.length <= 1) return;

    this.boundOnKeyDown = this.onKeyDown.bind(this);
    this.prevBtn?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
    this.nextBtn?.addEventListener('click', () => this.goTo(this.currentIndex + 1));
    this.addEventListener('keydown', this.boundOnKeyDown);

    this.goTo(this.currentIndex, { animate: false });
  }

  disconnectedCallback() {
    this.removeEventListener('keydown', this.boundOnKeyDown);
  }

  onKeyDown(event) {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.goTo(this.currentIndex - 1);
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.goTo(this.currentIndex + 1);
    }
  }

  normalizeIndex(index) {
    const total = this.slides.length;
    return ((index % total) + total) % total;
  }

  goTo(index, { animate = true } = {}) {
    if (this.slides.length === 0) return;

    const nextIndex = this.normalizeIndex(index);
    if (nextIndex === this.currentIndex && animate) return;
    if (this.isAnimating) return;

    const currentSlide = this.slides[this.currentIndex];
    const nextSlide = this.slides[nextIndex];

    if (!animate || this.reducedMotion || !currentSlide || currentSlide === nextSlide) {
      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === nextIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      this.currentIndex = nextIndex;
      return;
    }

    this.isAnimating = true;
    nextSlide.classList.add('is-active');
    nextSlide.setAttribute('aria-hidden', 'false');
    currentSlide.classList.remove('is-active');
    currentSlide.setAttribute('aria-hidden', 'true');
    this.currentIndex = nextIndex;

    window.setTimeout(() => {
      this.isAnimating = false;
    }, 450);
  }
}

if (!customElements.get('product-showcase')) {
  customElements.define('product-showcase', ProductShowcase);
}
